import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Helmet } from "react-helmet";
import headerLogo from './../../../assets/new-logo.svg';
import { Button, FormGroup } from "react-bootstrap";
import {Link, withRouter} from "react-router-dom";
import "./password-change.scss";
import { toast } from 'react-toastify';
import * as api from "../../../api";
import {Segment,Input, Icon} from "semantic-ui-react";

function mapStateToProps(state) {
    return {

    };
}

class PasswordChange extends Component {

    passwordRegex = "^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&\\-_]).{6,}$";
    passwordError = "Passwords must be at least 6 characters and contain at least one uppercase letter, one lowercase letter, one number, and one special character (one of #?!@$%^&-_).";

    constructor(props)
    {
        super(props);

        this.state = {
            token: "",
            password: "",
            passwordConfirm: "",
            doPasswordsMatch: true,
            showPassword: false
                };

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    doPasswordsMatch() {
    

        return this.state.password.length > 0 &&
            (this.state.password === this.state.passwordConfirm);
    }

    componentDidMount () {
        let { token } = this.props.computedMatch.params;
        this.setState({token});
    }

    handleChange = event => {
        this.setState({ [event.target.id]: event.target.value });
    };

    handleSubmit = (event) => {
        event.preventDefault();

        const doPasswordsMatch = this.doPasswordsMatch();
        this.setState({ doPasswordsMatch });

        if(!doPasswordsMatch)
        { return; }

        api.changePassword(this.state.token, this.state.password)
            .then((response) => {
                if(response.hasChanged === true)
                {
                    toast.info("Password has been reset, please log in with your new password", {
                        position: toast.POSITION.TOP_RIGHT,
                        onClose: () => { this.props.history.push("/"); }
                    });
                }
                else
                {
                    toast.error("Password could not be reset, token may have expired, please try resetting your password again", {
                        position: toast.POSITION.TOP_RIGHT,
                        onClose: () => { this.props.history.push("/password-reset"); }
                    });
                }

            });
    }

    render() {
        return (
            <div className="login">

                <Helmet>
                    <title>Inenco Portal | Change Password</title>
                </Helmet>

                <img src={headerLogo} alt="header-logo" className="login-logo" />
                    <React.Fragment>
                        <h4>Change Password</h4>

                        <form onSubmit={this.handleSubmit}>
                        <FormGroup controlId="password" bsSize="large">
    <span>Please enter your new password:</span>
    <Input id="password"
    fluid
        type={this.state.showPassword ? 'text' : 'password'}
        icon={
            <Icon
                name={this.state.showPassword ? 'eye slash outline' : 'eye'}
                link
                onClick={() => this.setState({ showPassword: !this.state.showPassword })}
            />
        }
        placeholder="New Password"
        onChange={this.handleChange}
        required
        pattern={this.passwordRegex}
        title={this.passwordError}
    />
</FormGroup>

<FormGroup controlId="passwordConfirm" bsSize="large">
    <span>Please confirm your new password:</span>
    <Input  id="passwordConfirm"
    fluid
        type={this.state.showPassword ? 'text' : 'password'}
        icon={
            <Icon
                name={this.state.showPassword ? 'eye slash outline' : 'eye'}
                link
                onClick={() => this.setState({ showPassword: !this.state.showPassword })}
            />
        }
        placeholder="Confirm New Password"
        onChange={this.handleChange}
        required
        pattern={this.passwordRegex}
        title={this.passwordError}
    />
</FormGroup>
                            {!this.state.doPasswordsMatch &&
                            <Segment inverted color='red'>
                                Passwords do not match, please confirm they are the same and try again.
                            </Segment>
                            }
                            <div className="button-div">
                                <Link to="/">
                                    <Button
                                        block
                                        bsSize="large"
                                        type="button"
                                        className="cancel-button"
                                    >
                                        cancel
                                    </Button>
                                </Link>

                                <Button
                                    block
                                    bsSize="large"
                                    type="submit"
                                    className="submit-button"
                                >
                                    change password
                                </Button>
                            </div>
                        </form>
                    </React.Fragment>
            </div>
        );
    }
}

export default connect(
    mapStateToProps,
)(withRouter(PasswordChange));